import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { HttpLoaderService } from '../../shared/loader/http-loader.service';

const SKIP_LOADER_HEADER = 'X-Skip-Loader';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.headers.has(SKIP_LOADER_HEADER)) {
    const reqSemHeader = req.clone({ headers: req.headers.delete(SKIP_LOADER_HEADER) });
    return next(reqSemHeader);
  }

  const loader = inject(HttpLoaderService);
  loader.notifyRequestStart();
  return next(req).pipe(finalize(() => loader.notifyRequestEnd()));
};
